import { EncryptedInstructionDocumentTypeRequest } from "../../../../../../../Wrap/Models/Models/Documents/InstructionDocuments/EncryptedInstructionDocumentTypeRequest";
import { SingleDataStore } from "../../../../../../Shared/Stores/SingleDataStore";
import { SingleDataStoreDispacher } from "../../../../../../Shared/Stores/SingleDataStoreDispacher";

export const IllustrationDispatcher: SingleDataStoreDispacher<
    EncryptedInstructionDocumentTypeRequest[]
> = new SingleDataStoreDispacher<EncryptedInstructionDocumentTypeRequest[]>();
export const IllustrationStore: SingleDataStore<EncryptedInstructionDocumentTypeRequest[]> = new SingleDataStore<
    EncryptedInstructionDocumentTypeRequest[]
>(IllustrationDispatcher);
